

const Navbar = () => {
    return ( 
        <nav className="navbar">
            <h1>THE FLOW WALL DESC</h1>
            <div className="Links">
                <a href="/">HOME</a>
                <a href="/" style={{
                    color:'white',
                    backgroundColor:'#630376',
                    borderRadius: '8px'
                }}> NEW BLOG</a>
                <a href="/">CONTACT</a>
            </div>
        </nav>
     );
}
 
export default Navbar;